import { Box, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import React from 'react';
import { TldOfferWidgetModule } from '../tldOfferWidget.module';
import { TldOfferPricingSkeleton } from './TldOfferPricingSkeleton';
import s from './tldOfferCard.scss';
export const TldOfferCardSkeleton = _ref => {
  let dataHook = _ref.dataHook;
  const CardContainer = TldOfferWidgetModule.SDK.Layouts.CardContainer;
  return /*#__PURE__*/React.createElement(CardContainer, {
    dataHook: dataHook
  }, /*#__PURE__*/React.createElement(SkeletonGroup, {
    skin: "light",
    backgroundColor: "white"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "10px"
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "115px",
    height: "24px"
  }), /*#__PURE__*/React.createElement(TldOfferPricingSkeleton, null), /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "100%",
    height: "24px"
  }))));
};
//# sourceMappingURL=TldOfferCardSkeleton.js.map